import React from 'react'
import { IntegrationsMagentoSec } from './integrationsMagentoSec'

export const IntegrationsMagento = () => {
  return (
    <IntegrationsMagentoSec />
  )
}
